import { useCallback, useState } from 'react'
import { informativoProdutoService } from '@/services/informativoProdutoService'
import type { ArquivoInformativo } from '@/types/informativo'

const MENSAGEM_PADRAO = 'Não foi possível baixar o informativo. Tente novamente.'

/**
 * Estado do download do PDF informativo do produto: o mesmo na aba Informativo do detalhe e
 * na lista do consultor ("Abrir →"). `baixandoId` diz qual documento está em curso — a lista
 * e o histórico têm vários botões e só o da linha clicada deve ficar ocupado.
 *
 * Onda 5 (AN-11 §1.4): reaproveitado do antigo "Manual PDF"; agora recebe o informativo
 * vigente (ou uma versão do histórico, no back-office) e baixa pelo `/arquivo` auditado.
 */
export const useBaixarManual = () => {
  const [baixandoId, setBaixandoId] = useState<string | null>(null)
  const [erro, setErro] = useState<string | null>(null)

  const baixar = useCallback(async (arquivo: ArquivoInformativo): Promise<boolean> => {
    setBaixandoId(arquivo.documentoId)
    setErro(null)
    try {
      await informativoProdutoService.baixar(arquivo)
      return true
    } catch (e) {
      const m = (e as { message?: unknown } | null)?.message
      setErro(typeof m === 'string' && m ? m : MENSAGEM_PADRAO)
      return false
    } finally {
      setBaixandoId(null)
    }
  }, [])

  const limparErro = useCallback(() => setErro(null), [])

  return { baixar, baixandoId, baixando: baixandoId !== null, erro, limparErro }
}
